<template>
  <div class="successful_message mt-6 rounded-card bg-surface p-6 text-center text-ink shadow-[inset_0_3px_0_0_#48c78e]">
    <img
      :src="$asset('/images/forms/success_check@2x.png')"
      class="success_graphic"
      alt="Welcome to Hypefactors. Its gonna be hypetastic"
      width="150"
    >

    <h3 class="mb-2 font-display text-lg font-bold text-ink">
      {{ $t('pages.register.high_five') }}
    </h3>

    <p v-if="!journalist" class="mb-3 font-sans text-sm leading-relaxed text-muted">
      {{ $t('pages.register.confirmation_sent') }}
    </p>

    <p v-if="journalist" class="mb-3 font-sans text-sm leading-relaxed text-muted">
      {{ $t('pages.register.confirmation_sent_journalists') }}
    </p>

    <p class="font-sans text-sm leading-relaxed text-muted">
      {{ $t('pages.register.if_you_have_questions') }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    journalist: {
      type: Boolean,
      default: false
    }
  }
}
</script>
